<div class="card">
        <div class="flexbox1">  
            <div class="txt">
                <!-- <p class="bonus-title"> New offers coming soon!!</p> -->
            </div>      
      </div>
</div>